
import { route_castInfo } from "@/router";
import HomeCastCard from "@/components/HomeCastCard.vue";
import { castCardSize, castCardSizeType, ICast } from "@/types/cast";
import Vue from "vue";
export default Vue.extend({
  components: {
    HomeCastCard,
  },
  data(): {
    cardSize: castCardSizeType;
  } {
    return {
      cardSize: castCardSize.Mini
    };
  },
  props: {
    castData: {
      type: Array as () => ICast[],
    },
  },
  methods: {
    toUserInfoPage(data: ICast) {
      this.$store.dispatch("cast/setCastData", data);
      this.$router.push(route_castInfo + data.uid);
    },
  },
});
